var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgT1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    width: 163.75,
    height: 163,
    viewBox: "0 0 163.75 163",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    transform: "translate(-117.25 -2005)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_2",
    "data-name": 2,
    transform: "translate(141.25 2112)",
    fill: "#fcd578",
    fontSize: 90,
    fontFamily: "Oswald-Bold, Oswald",
    fontWeight: 700,
    letterSpacing: "-0.04em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -23.13,
    y: 0
  }, "2")), /*#__PURE__*/React.createElement("text", {
    id: "Out_of",
    "data-name": "Out of",
    transform: "translate(171 2069.5)",
    fill: "#fcd578",
    fontSize: 44,
    fontFamily: "Oswald-Light, Oswald",
    fontWeight: 300,
    letterSpacing: "-0.04em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "OUT"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 44
  }, "OF")), /*#__PURE__*/React.createElement("text", {
    id: "_3",
    "data-name": 3,
    transform: "translate(257 2112)",
    fill: "#fcd578",
    fontSize: 90,
    fontFamily: "Oswald-Bold, Oswald",
    fontWeight: 700,
    letterSpacing: "-0.04em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -23.13,
    y: 0
  }, "3")), /*#__PURE__*/React.createElement("text", {
    id: "callers_are_being_threatened",
    "data-name": "callers are being threatened",
    transform: "translate(198.25 2140)",
    fill: "#1d1d1d",
    fontSize: 20,
    fontFamily: "Oswald-Medium, Oswald",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -51.39,
    y: 0
  }, "CALLERS ARE"), /*#__PURE__*/React.createElement("tspan", {
    x: -74.82,
    y: 22
  }, "BEING THREATENED")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgT1);
export default __webpack_public_path__ + "static/media/t1.f6e1e04c01c3ea9724404c59aa775ff3.svg";
export { ForwardRef as ReactComponent };